import React from "react";
import withTranslation from "../../translation";
import PropTypes from "prop-types";
import styles from "./index.css";

const SkipToContent = ({ formatTranslation }) => (
  <a
    href="#chrome-app-container"
    className={styles.skipLink}
    data-testid="skip-to-content"
  >
    {formatTranslation("Accessibility.SkipToContent")}
  </a>
);

SkipToContent.propTypes = {
  formatTranslation: PropTypes.func.isRequired
};

export default withTranslation(SkipToContent);



// WEBPACK FOOTER //
// ./template/components/Header/SkipToContent/index.js